// external dependencies
import React, { memo } from 'react'
import { string } from 'prop-types'
import styled from '@emotion/styled'

// constants
import { MQ } from 'utils/styleHelpers'

// components
import BuyerzoneDark from 'components/BuyerzoneLogo/BuyerzoneDark'

// styled components
const ImageContainer = styled.div`
	margin-bottom: 10px;

	${MQ.S} {
		margin-bottom: 60px;
	}
`

const Header = ({ logoWidth, logoHeight }) => {
	return (
		<ImageContainer>
			<BuyerzoneDark height={logoHeight} width={logoWidth} />
		</ImageContainer>
	)
}

Header.propTypes = {
	logoWidth: string,
}

export default memo(Header)
